import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const alignCls = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-3xl ${alignCls}`} data-id="element-63" data-mp="3k0yjaffwbfce">
      {kicker && <p className="mb-3 font-display text-lg font-bold uppercase tracking-wider text-alert sm:text-xl" data-id="element-64" data-mp="bjtylzo7iu3p">{kicker}</p>}
      <h2 className="font-display text-[34px] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-65" data-mp="gi56w5yuswjt">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-body sm:text-xl" data-id="element-66" data-mp="6tdk0c8nh2fr">{subtitle}</p>}
    </div>;
}